"use client";

import { ReactNode } from "react";

export default function DarkModeButton({
  children,
  className,
}: Readonly<{ children: ReactNode; className: string }>) {
  const handleClick = () => document.documentElement.classList.toggle("dark");

  return (
    <button className={className} onClick={() => handleClick()}>
      {children}
    </button>
  );
}
